import { AbstractControl, ValidationErrors } from '@angular/forms';
import { regex } from './regex';

export const emailValidator = (control: AbstractControl): ValidationErrors | null => {
  const isOk = regex.email.test(control.value);
  return !isOk ? { email: { value: control.value, text: 'Email is incorrect' } } : null;
};

export const numbersValidator = (control: AbstractControl): ValidationErrors | null => {
  const isOk = regex.numbers.test(control.value);
  return !isOk ? { numbers: { value: control.value, text: 'Digits only' } } : null;
};

export const latinAndSpacesValidator = (control: AbstractControl): ValidationErrors | null => {
  const isOk = regex.latinAndSpaces.test(control.value);
  return !isOk ? { latinAndSpaces: { value: control.value, text: 'Latin letters and spaces only' } } : null;
};
